export default __webpack_public_path__ + "static/media/body-section-biceps.497a721e.png";